import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { successCaseArticlesGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import SuccessCasesView from '@/src/views/success-cases/SuccessCasesView';

function SuccessCasesPage({ doc = {}, preview }) {
  return (
    <AssembleLayout Layout={MainLayout} Component={SuccessCasesView} doc={doc} preview={preview}>
      <NextSeo
        title="Casos de Sucesso"
        description="Saiba mais sobre como nossos parceiros estão utilizando a Eskolare para melhorar a eficiência e aumentar suas receitas."
        openGraph={{
          title: 'Casos de Sucesso',
          url: urlHostResolver('/success-cases'),
        }}
      />
    </AssembleLayout>
  );
}

SuccessCasesPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticProps(context) {
  const { preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const graphQuery = `{
    success-cases-article {
      cover
      title
      subtitle
      content
      date
      author {
        name
        avatar
      }
    }
  }`;

  const articles = await successCaseArticlesGet({ graphQuery }, { ref });

  return {
    props: { doc: { articles }, preview },
    revalidate: 180,
  };
}

export default SuccessCasesPage;
